import { IProfForm } from '../../../components/FormContainers/CreateProfessional/type';
import { IFormDialog } from './types';

export const createProfessionalInitialValues: IProfForm = {
  // step1
  title: '',
  first_name: '',
  last_name: '',
  email: '',
  phone_number: '',
  afm: '',
  // step2
  category_level_1: [],
  // specialty: [],
  specialty_lvl2: [],
  services: '',
  productions: '',
  languages: [],
  regions: [],
  website: '',
  facebook: '',
  youtube: '',
  linkedin: '',
  instagram: '',
  vimeo: '',
  // step 3
  city: null,
  tk: null,
  address: '',
  address_number: null,
  latitude: null,
  longitude: null,
  //step 4
  thumbnail: null,
  media: null,
  //step5
  resume: null,
  attached_files: null,
};

export const initialValues: IFormDialog = {
  first_name: '',
  last_name: '',
  email: '',
  phone: '',
  co_name: '',
  descr_co: '',
  termsAndConditions: false
};

export const initialValues1 = {
  free_text: '',
  specialty: '',
  services: '',
};